import { render } from "./IconArrowThin.vue?vue&type=template&id=6c676bcc"
import script from "./IconArrowThin.vue?vue&type=script&lang=js"
export * from "./IconArrowThin.vue?vue&type=script&lang=js"
script.render = render

export default script